// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"CompanyCommitteeList_listContainer__1JS7e"};